/**
 * Mock data for the generic AttributeMapping component
 */

import {
  type AttributeMappingConfig,
  type GenericAttributeMapping,
} from './types';

// ServiceNow integration configuration
export const serviceNowConfig: AttributeMappingConfig = {
  saviyntApp: {
    name: 'Saviynt',
    icon: 'SaviyntLogoFilledSeparateColors',
    fields: [
      'firstName',
      'lastName',
      'displayName',
      'creationDate',
      'owner',
      'status',
      'emailAddress',
    ],
    allowCustomValues: false,
  },
  externalApp: {
    name: 'ServiceNow',
    icon: 'ServiceNow',
    fields: [], // External app fields are entered by user
    allowCustomValues: true,
  },
};

// Zendesk integration configuration (example from design)
export const zendeskConfig: AttributeMappingConfig = {
  saviyntApp: {
    name: 'Saviynt',
    icon: 'SaviyntLogoFilledSeparateColors',
    fields: [
      'firstName',
      'lastName',
      'displayName',
      'emailAddress',
      'ticketStatus',
      'priority',
    ],
    allowCustomValues: false,
  },
  externalApp: {
    name: 'Zendesk',
    icon: 'Zendesk',
    fields: [], // External app fields are entered by user
    allowCustomValues: true,
  },
};

// Salesforce integration configuration
export const salesforceConfig: AttributeMappingConfig = {
  saviyntApp: {
    name: 'Saviynt',
    icon: 'SaviyntLogoFilledSeparateColors',
    fields: [
      'firstName',
      'lastName',
      'displayName',
      'emailAddress',
      'accountId',
      'status',
    ],
    allowCustomValues: false,
  },
  externalApp: {
    name: 'Salesforce',
    icon: 'Salesforce',
    fields: [], // External app fields are entered by user
    allowCustomValues: true,
  },
};

// Default initial mappings (2 rows with firstName and lastName)
export const getDefaultMappings = (): GenericAttributeMapping[] => [
  {
    id: 'mapping-1',
    saviyntField: 'firstName',
    externalAppField: '',
    saviyntValue: '',
    externalAppValue: '',
  },
  {
    id: 'mapping-2',
    saviyntField: 'lastName',
    externalAppField: '',
    saviyntValue: '',
    externalAppValue: '',
  },
];

// Mock initial mappings for testing
export const mockInitialMappings: GenericAttributeMapping[] = [
  {
    id: 'mapping-1',
    saviyntField: 'firstName',
    externalAppField: 'userObj.firstname',
    saviyntValue: '',
    externalAppValue: '',
  },
  {
    id: 'mapping-2',
    saviyntField: 'lastName',
    externalAppField: 'userObj.lastname',
    saviyntValue: '',
    externalAppValue: '',
  },
  {
    id: 'mapping-3',
    saviyntField: 'displayName',
    externalAppField: 'name',
    saviyntValue: '',
    externalAppValue: '',
  },
];

// Default configuration for CreateAccount component
export const defaultConfig = serviceNowConfig;
